var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { "background-color": "#FAF9F6" },
      style:
        _vm.isDesktop() && !_vm.selected ? "padding-bottom: 320px" : "50px",
    },
    [
      _c("TaxaPodFetestiNavigation"),
      _c("Steps", { attrs: { "current-page": 2 } }),
      _c("div", { staticClass: "section d-flex justify-content-center" }, [
        _c("div", { staticClass: "container-medium purchase-wrapper" }, [
          _c(
            "div",
            { staticClass: "text-center pt-2" },
            [
              _vm.category
                ? _c("Heading", {
                    attrs: {
                      title: _vm.$t("buy_toll"),
                      routeName: "cart",
                      alignment: "text-center",
                    },
                  })
                : _vm._e(),
              _c("p", { staticClass: "pt-3" }, [
                _c("span", { staticClass: "main-text" }, [
                  _vm._v(
                    _vm._s(_vm.$tc("step", 2)) +
                      ": " +
                      _vm._s(_vm.$t("choose_passings_number"))
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "container container-medium" }, [
        _c("div", { staticClass: "auto-rov-catA" }, [
          _vm.category && _vm.icons
            ? _c("div", { staticClass: "d-flex align-center" }, [
                _c("div", {
                  staticClass: "icon cat-icon m-0",
                  class: _vm.icons[_vm.category.id - 1].icon,
                  attrs: { alt: "" },
                }),
                _c("div", { staticClass: "txt" }, [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.category.desc) },
                  }),
                  _vm._v(
                    " / " +
                      _vm._s(_vm.capitalize(_vm.$t("tollWord", 3))) +
                      " " +
                      _vm._s(_vm.category.title)
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.category && !_vm.loading
        ? _c("div", { staticClass: "container container-medium mt-3" }, [
            _c(
              "div",
              { staticClass: "row py-3" },
              _vm._l(_vm.category.prices, function (item, key) {
                return _c(
                  "div",
                  {
                    key: key,
                    staticClass: "col-lg-4 col-md-4 col-xs-12 col-12",
                    class: _vm.isMobile() ? "mb-3" : "",
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: {
                              el: ".form-wrapper",
                              offset: -92, // -- 92px is the height of the fixed header
                            },
                            expression:
                              "{\n                        el: '.form-wrapper',\n                        offset: -92, // -- 92px is the height of the fixed header\n                    }",
                          },
                        ],
                        staticClass: "card card-pointer",
                        class: [
                          { "card-primary": _vm.passes == key && _vm.selected },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.choosePasses(key)
                          },
                        },
                      },
                      [
                        _vm.passes == key && _vm.selected
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "elipse-complete position-absolute margin-minus",
                              },
                              [_c("div", { staticClass: "icon v-icon" })]
                            )
                          : _vm._e(),
                        _c("span", { staticClass: "number-of-passes" }, [
                          _vm._v(
                            _vm._s(item.valability.quantity) +
                              " " +
                              _vm._s(
                                _vm.$tc("passing", item.valability.quantity)
                              )
                          ),
                        ]),
                        _c("p", { staticClass: "card-text" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(item.value_ron) +
                                " " +
                                _vm._s(_vm.$tc("currency", item.value_ron))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.form_visible
        ? _c(
            "div",
            { staticClass: "container container-xs no-padding-mobile" },
            [
              _c(
                "div",
                { attrs: { id: "form-1" } },
                [
                  !_vm.loading
                    ? [
                        !_vm.vehicle
                          ? [
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "form-group p-relative" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("label_license_plate"))
                                      ),
                                    ]),
                                    _vm.errorMsgs.plateNo
                                      ? _c(
                                          "span",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.errorMsgs.plateNo) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("input", {
                                      staticClass: "form-control",
                                      class: {
                                        "has-error": _vm.errorMsgs.plateNo,
                                      },
                                      attrs: {
                                        type: "text",
                                        dusk: "plate-nr-toll",
                                      },
                                      domProps: { value: _vm.plateNo },
                                      on: {
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              $event.keyCode !== 38
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              $event.keyCode !== 40
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                        ],
                                        input: (e) =>
                                          (_vm.plateNo = e.target.value),
                                      },
                                    }),
                                    _vm.isLoggedIn &&
                                    _vm.plateNo &&
                                    _vm.showAutocomplete
                                      ? _c("autocomplete", {
                                          attrs: {
                                            type: "tpf",
                                            search: _vm.plateNo,
                                          },
                                          on: {
                                            destroy: _vm.destroyAutocomplete,
                                            choose: _vm.setSearchedVehicle,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("label_chasis_number"))
                                    ),
                                  ]),
                                  _vm.errorMsgs.chasisNo
                                    ? _c(
                                        "span",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.errorMsgs.chasisNo) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.chasisNo,
                                        expression: "chasisNo",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "has-error": _vm.errorMsgs.chasisNo,
                                    },
                                    attrs: { type: "text", dusk: "chasisNo" },
                                    domProps: { value: _vm.chasisNo },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.chasisNo = $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                                _vm.countries
                                  ? _c("div", { staticClass: "form-group" }, [
                                      _c(
                                        "label",
                                        { attrs: { for: "taraInmatriculare" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_registration_country"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.country,
                                              expression: "country",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { id: "taraInmatriculare" },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.country = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        _vm._l(
                                          _vm.countries,
                                          function (c, key) {
                                            return _c(
                                              "option",
                                              {
                                                key: key,
                                                domProps: { value: c.id },
                                              },
                                              [_vm._v(_vm._s(c.country))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "form-group mb-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("label_motif")) +
                                        " (" +
                                        _vm._s(_vm.$t("label_optional_field")) +
                                        ")"
                                    ),
                                  ]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.reason,
                                        expression: "reason",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.reason },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.reason = $event.target.value
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                            ]
                          : _vm._e(),
                        _vm.vehicle
                          ? [
                              _vm.noChasisOnLoad
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("label_chasis_number"))
                                      ),
                                    ]),
                                    _vm.errorMsgs.chasisNo
                                      ? _c(
                                          "span",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.errorMsgs.chasisNo) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.chasisNo,
                                          expression: "chasisNo",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "has-error": _vm.errorMsgs.chasisNo,
                                      },
                                      attrs: { type: "text" },
                                      domProps: { value: _vm.chasisNo },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.chasisNo = $event.target.value
                                        },
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c("AddProductForVehicle", {
                                    attrs: {
                                      vehicle: _vm.vehicle,
                                      type: "toll",
                                      "hide-btn": true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "sms-notification" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.sms_confirm_notification,
                                  expression: "sms_confirm_notification",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.sms_confirm_notification
                                )
                                  ? _vm._i(_vm.sms_confirm_notification, null) >
                                    -1
                                  : _vm.sms_confirm_notification,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.sms_confirm_notification,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.sms_confirm_notification =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.sms_confirm_notification = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.sms_confirm_notification = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$tc(
                                    "sms_confirm_notification_peaj",
                                    Math.ceil(_vm.getSmsSetting.value),
                                    { price: _vm.getSmsSettingMessage() }
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.selected
        ? _c("div", { staticClass: "container container-xs" }, [
            !_vm.loading
              ? _c(
                  "div",
                  {
                    staticClass:
                      "action-button action-button-big-desktop d-flex justify-content-end",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-purple",
                        attrs: { type: "submit", dusk: "add-to-desktop-cart" },
                        on: {
                          click: function ($event) {
                            return _vm.addToCart()
                          },
                        },
                      },
                      [
                        !_vm.getEditProduct
                          ? [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")]
                          : [_vm._v(" " + _vm._s(_vm.$t("continue")) + " ")],
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }